import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useThrottleFn } from 'ahooks';
import { useEffect } from 'react';

import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
import { computed, observable } from 'mobx';
import { noop } from '@src/utils/common-util';

class pageSwiperStore {
  /**
   * swiperOptions 默认的属性值
   * @type {{simulateTouch: boolean, observeParents: boolean, releaseOnEdges: boolean, effect: string, mousewheel: boolean, fadeEffect: {}, slidesPerView: number, observe: boolean, direction: string}}
   */
  swiperOptions = {
    direction: 'vertical',
    slidesPerView: 1,
    observe: true,
    observeParents: true,
    mousewheel: false,
    releaseOnEdges: true,
    simulateTouch: false
  };

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: this.swiperOptions
  });

  @observable onChangeFooterState = noop;
  // 是否允许页面上有弹窗开启的时候滚动
  allowScrollWhileModalOpen = false;
  // 是否允许滚动
  @observable isScrollEnabled = true;
  constructor({ effectMode = pageSwiperEffect.FADE, ...rest } = {}) {
    Object.assign(this, rest);
    this.baseSwiperStore.swiperOptions = { ...this.baseSwiperStore.swiperOptions, ...effectMode };
  }

  @computed
  get activeIndex() {
    return this.baseSwiperStore.activeIndex;
  }

  /**
   * 全屏滚动鼠标监听
   * 因为使用swiper自带的鼠标上线滚动会出现页面闪动的问题
   * 因此通过监听鼠标滚动事件来实现全屏滚动
   * @param ev
   */
  handleScroll = ev => {
    // console.log(this.isScrollEnabled, 'this.isScrollEnabled');

    if (!this.isScrollEnabled) {
      return;
    }
    if (ev.target.parentNode && ev.target.parentNode.className.indexOf('c-age-tips-content') > -1) {
      return;
    }

    let isScrollUp;
    if (ev.wheelDelta) {
      isScrollUp = ev.wheelDelta > 0;
    } else {
      isScrollUp = ev.detail < 0;
    }

    const currentActiveIndex = this.baseSwiperStore.activeIndex;
    const nextActiveIndex = currentActiveIndex + (isScrollUp ? -1 : 1);

    /**
     * 禁止滚动到 -1 屏
     */
    if (nextActiveIndex < 0) {
      return;
    }

    /**
     * 获取总屏数
     */
    const totalSwiperSlides = this.baseSwiperStore.swiperRef.current.swiper.slides.length;

    /**
     * 其他溢出场景禁止
     */
    if (nextActiveIndex > totalSwiperSlides) {
      return;
    }
    /**
     * footer状态控制
     */
    if (nextActiveIndex === totalSwiperSlides) {
      this.onChangeFooterState?.(true);
    }
    if (nextActiveIndex === totalSwiperSlides - 1) {
      this.onChangeFooterState?.(false);
    }
    /**
     * 正常场景允许滚动
     */
    this.baseSwiperStore.onChange(nextActiveIndex);
  };

  /**
   * 是否有弹窗打开
   * @returns {boolean}
   */
  hasModalOpen = () => {
    return document.querySelectorAll('[class*=openModal][data-open=true]').length || document?.querySelectorAll('[class*=PhotoView-Portal]').length;
  };

  use() {
    const { run: onScroll } = useThrottleFn(
      (...args) => {
        if (!this.allowScrollWhileModalOpen && this.hasModalOpen()) {
          return;
        }
        this.handleScroll(...args);
      },
      { wait: 1500, trailing: false }
    );
    this.onScroll = onScroll;
    useEffect(
      () => {
        document.addEventListener('wheel', onScroll, false);
        return () => {
          document.removeEventListener('wheel', onScroll, false);
        };
      },
      [onScroll]
    );
  }
}

export default pageSwiperStore;
